import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { createFrontendPlugin } from '@backstage/frontend-plugin-api';

const apiLinterEntityContent = EntityContentBlueprint.make({
  name: 'linter',
  params: {
    path: '/linter',
    title: 'Linter',
    group: 'documentation',
    filter: { kind: 'api' },
    loader: () => import('./components').then(m => <m.ApiLinterContent />),
  },
});

export const apiLinterPlugin = createFrontendPlugin({
  pluginId: 'api-linter',
  extensions: [apiLinterEntityContent],
});
